import { AfterViewChecked, Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { BookingModel, BookingService, LayoutService, NavigationResolver, NavigationService, ActiveRentalService } from 'app-components';
import * as moment from 'moment';
import { AppIntegrationService, AppSettingsService } from 't4-app-integration';
import { CustomerInfo, ObjectTypeInfo, PageBase, PriceModel, BookingErrorCode, RentalStatus } from 't4core';
import { AddonPopupComponent } from '../../dialogs/addon-popup/addon-popup.component';
import { TravelRangeDialog } from '../../dialogs/travel-range/travel-range.component';

@Component({
    selector: 'app-unconfirmed-booking',
    templateUrl: './unconfirmed-booking.component.html',
    standalone: false
})
export class UnconfirmedBookingComponent extends PageBase implements OnInit, AfterViewChecked {
  public bookingState: BookingModel;
  public user: string;
  public useSavedCard: boolean = true;
  public terms: boolean = false;
  public scrolledToBottom: boolean = false;
  public quarterFromNow: moment.Moment = moment().add(15, 'minutes');
  public hasBookingId: boolean = false;
  public currentPrice: PriceModel = new PriceModel();
  public addableProducts: ObjectTypeInfo[];
  public addonsFromPopup: ObjectTypeInfo[];
  public specialConditionApproved: boolean = false;
  public loading: boolean = false;
  public loadingMessageKey: string = 'Intellitrailer.UnconfirmedBooking.txtProcessingBooking';
  public loadingMessageText: string = 'Processing booking...';
  public paymentFailed: boolean = false;
  public paymentCancelled: boolean = false;
  private currentBookingId: number;
  public showVerifySpinner: boolean = false;
  public verifyProgressCount: number = 0;
  private paymentSnapshotVersion: number = 0;
  private paymentAttemptInProgress: boolean = false;
  private readonly verifyProgressMaxSeconds: number = 15;
  private verifyProgressIntervalId: ReturnType<typeof setInterval> | null = null;
  constructor(private navigator: NavigationService, el: ElementRef, private appService: AppIntegrationService, private BookingDataService: BookingService, public resolver: NavigationResolver, public layout: LayoutService, public appSettings: AppSettingsService, private rentalService: ActiveRentalService) {
    super(el);

    this.bookingState = BookingDataService.getBookingState();
    this.terms = this.bookingState?.acceptedTerms;
    this.user = this.appSettings.userId;
  }

  async ngOnInit(): Promise<void> {
    console.log("BookingState on unconfirmed booking: ", this.bookingState);
    console.log("typeclass", this.bookingState?.booking?.PrimaryType?.TypeClassId);
    if (this.bookingState?.booking?.PrimaryType?.TypeClassId == 5) //Nuwiel check
    {
      const dialogRef = this.Dialog.open(TravelRangeDialog, {
        disableClose: true,
        width: '350px',
        position: { top: '50px' }
      });
      dialogRef.afterClosed().subscribe(x => {
        this.bookingState.booking.TravelRange = x;
      })
    }   
    this.hasBookingId = this.bookingState.booking && this.bookingState.booking.Id ? true : false;

    if (this.user) {
      //Check if user has saved customer
      this.bookingState.booking.Customer = await this.Api.get<CustomerInfo>("/Rental/FindCustomerByUser");
    }

    if (!this.bookingState.booking.PrimaryObjectTypeId) {
      this.Insights.trackTrace("Type is nil: ", { RentalInfo: JSON.stringify(this.bookingState.booking) });
      this.navigator.executeCommand('Back');
    }

    //If there is no Special condion on the rentalType, when we set it to true.
    if (!this.bookingState.booking.PrimaryType.SpecialCondition) {
      this.specialConditionApproved = true;
    }
  }

  ngAfterViewChecked(): void {
    const visible = this.isElementVisible('continue-to-agree');
    if (this.scrolledToBottom !== visible) {
      Promise.resolve().then(() => this.scrolledToBottom = visible);
    }
  }

  public back() {
    this.navigator.back();
  }

  public async prepareForNext() {
    if (this.bookingState.existingBooking) {
      var oldPrice = this.bookingState.booking.Price.Payments[0]?.Amount;
      const diff = oldPrice != null ? this.currentPrice.ToPay - oldPrice : this.currentPrice.ToPay;
      console.log("price difference", diff);
      if (diff !== 0) {
        var ret = await this.UI.confirm("Intellitrailer.Rental.ChangeBooking.headConfirmChangeBooking", "Confirm change booking", "Intellitrailer.Rental.RentalBox.msgConfirmChangeBooking", "There is a price difference of while changing the booking. Would you like to pay and continue the change?");
        if (!ret) {
          return;
        } 
      }
    }
    var confirm = true; // await this.showAddonPopup(); - Only show one dialog currently (kept for future change of mind)
    if (confirm) this.goNext();
  }

  public async goNext() {
    // if (this.appSettings.appType == "web" || !this.appSettings.meetsMinimumAppVersion(4.10) || this.appSettings.contextId == "OKQ8Unmanned_API") {
      this.navigator.executeCommand("Next");
    // }
    // else {
    //   this.loading = true;
    //   this.loadingMessageKey = 'Intellitrailer.UnconfirmedBooking.txtProcessingBooking';
    //   this.loadingMessageText = 'Processing booking...';
    //   if (!this.user) {
    //     this.navigator.executeCommand("Next");
    //     return;
    //   }
    //   this.BookingDataService.saveState(this.bookingState);
    //   await this.handlePaymentFlow();
    // }
    
  }

  private async handlePaymentFlow() {
    try {
      // Setup customer
      let cus = await this.Api.get<CustomerInfo>("/Rental/FindCustomerByUser");
      if (!cus) cus = new CustomerInfo();

      this.BookingDataService.Query.Customer = cus;

      // Validate booking
      const validate = await this.BookingDataService.saveBooking(true, this.useSavedCard);

      if (validate.CustomerDenied) {
        this.loading = false;
        return;
      }

      if (validate.AggregatedResult === BookingErrorCode.Valid) {
        this.currentBookingId = validate.BookingId;
        await this.rentalService.setActiveRental(this.currentBookingId);

        if (validate.RequirePayment) {
          this.loadingMessageKey = 'Intellitrailer.UnconfirmedBooking.txtPreparingPayment';
          this.loadingMessageText = 'Preparing payment...';
          await this.startNativeDropIn(this.currentBookingId);
        } else {
          this.loading = false;
          this.navigateToConfirmation();
        }

      } else {
        this.loading = false;
        this.handleBookingErrors(validate);
      }

    } catch (err) {
      this.loading = false;
      console.error(err);
    }
  }
  public async startNativeDropIn(bookingId: number) {
    try {
      this.paymentAttemptInProgress = true;
      this.paymentFailed = false;
      this.paymentCancelled = false;
      this.showVerifySpinner = false;
      const deviceType = AppSettingsService.getDeviceType();
      const normalizedDeviceType = String(deviceType || "").toLowerCase();
      const platform = normalizedDeviceType === "android"
        ? "android"
        : normalizedDeviceType === "ios"
          ? "ios"
          : null;

      if (!platform) {
        this.paymentFailed = true;
        this.Insights.trackTrace("Unsupported device type for native payment", { rentalId: bookingId.toString(), deviceType: String(deviceType || "") });
        await this.UI.alert("Intellitrailer.Booking.UnconfirmedBooking.PaymentFailed", "Payment Failed", "Intellitrailer.Booking.UnconfirmedBooking.PaymentFailedMsg", "Native payment is not supported on this device. Please try again.");
        return;
      }

      const baseAppScheme = this.appSettings.appScheme ?? this.appSettings.settings.theme;
      const returnUrl = platform === "android" ? `adyencheckout://${baseAppScheme}` : `${baseAppScheme}://Booking/Payment`;
      console.log("returnUrl", returnUrl);
      let sessionResponse: any;
      let sessionCreated = false;

      for (let attempt = 0; attempt < 3; attempt++) {
        const paymentSnapshotVersion = this.paymentSnapshotVersion;
        sessionResponse = await this.Api.get<any>("Payment/Adyen/CreateSession", { id: bookingId, returnUrl, platform });

        if (paymentSnapshotVersion === this.paymentSnapshotVersion) {
          sessionCreated = true;
          break;
        }

        this.Insights.trackTrace("Adyen session recreated after payment update", {
          rentalId: bookingId.toString(),
          attempt: (attempt + 1).toString()
        });
      }

      if (!sessionCreated) {
        this.loading = false;
        this.paymentFailed = true;
        await this.UI.alert("Intellitrailer.Booking.UnconfirmedBooking.PaymentFailed", "Payment Failed", "Intellitrailer.Booking.UnconfirmedBooking.PaymentFailedMsg", "The payment process failed. Please try again.");
        return;
      }

      this.Insights.trackTrace("Adyen session created", { rentalId: bookingId.toString()});

      this.loading = false;
      const result = await this.appService.startAdyenPayment(sessionResponse);
      this.Insights.trackTrace("Adyen native result", { rentalId: bookingId.toString(), result: JSON.stringify(result || {}) });
      if (!result) {
        this.paymentFailed = true;
        return;
      }
      console.log("Payment result", result);
      const resultCode = String(result.resultCode || "").toLowerCase();
      if (resultCode === "authorised") {
        this.BookingDataService.restartSession(bookingId).then(() => {
          this.navigateToConfirmation();
        });
      } else if (resultCode === "received" || resultCode === "pending") {

        this.verifyProgressCount = 1;
        this.showVerifySpinner = true;
        this.startVerifyProgress();

        let paymentConfirmed = false;

        for (let i = 0; i < 5; i++) {
          await this.delay(3000); // wait 3 seconds
          paymentConfirmed = await this.Api.post<any>( "Rental/App/TreatPendingPaymentAsConfirmed",null,{ rentalId: bookingId } );
          console.log( "Payment confirmation attempt",i + 1,paymentConfirmed );
          if (paymentConfirmed) {
            break;
          } 
        }

        this.showVerifySpinner = false;
        this.stopVerifyProgress(true);

        if (paymentConfirmed) {
          this.BookingDataService.restartSession(bookingId).then(() => {
            this.navigateToConfirmation();
          });
        } else {
          this.paymentFailed = true;
          await this.UI.alert( "Intellitrailer.Booking.UnconfirmedBooking.PaymentFailed", "Payment Failed", "Intellitrailer.Booking.UnconfirmedBooking.PaymentFailedMsg","The payment process failed. Please try again.");
        }
      }
      else if (resultCode === "cancelled") {
        this.paymentCancelled = true;
        var x = await this.UI.alert("Intellitrailer.Booking.UnconfirmedBooking.PaymentCancelled", "Payment Cancelled", "Intellitrailer.Booking.UnconfirmedBooking.PaymentCancelledMsg", "The payment process was cancelled. Please try again.");

      } else {
        this.paymentFailed = true;
        var x = await this.UI.alert("Intellitrailer.Booking.UnconfirmedBooking.PaymentFailed", "Payment Failed", "Intellitrailer.Booking.UnconfirmedBooking.PaymentFailedMsg", "The payment process failed. Please try again.");
      }

    } catch (err) {
      this.showVerifySpinner = false;
      this.stopVerifyProgress(true);
      this.paymentFailed = true;
    } finally {
      this.paymentAttemptInProgress = false;
    }
  }
  public async retry() {
    this.loading = true;
    this.loadingMessageKey = 'Intellitrailer.UnconfirmedBooking.txtProcessingBooking';
    this.loadingMessageText = 'Processing booking...';
    this.BookingDataService.saveState(this.bookingState);
    await this.handlePaymentFlow();
  }
  public navigateToConfirmation() {
    this.navigator.executeCommand("Success", { rentalId: this.currentBookingId });
  }
  public async handleBookingErrors(validate) {
    if (validate.AggregatedResult == BookingErrorCode.LocationNotOpen) {
      var x = await this.UI.alert("Intellitrailer.Booking.UnconfirmedBooking.BookingErrorCodeNotOpenHead", "Invalid booking!", "Intellitrailer.Booking.UnconfirmedBooking.BookingErrorCodeNotOpenMsg", "The location is not open for pickup at the specified pickup time.");
    }
    else if (validate.AggregatedResult == BookingErrorCode.ObjectUnavailable) {
      var x = await this.UI.alert("Intellitrailer.Booking.UnconfirmedBooking.BookingErrorCodeObjectUnavailable", "Trailer Unavailable", "Intellitrailer.Booking.UnconfirmedBooking.BookingErrorUnavailableMsg", "The trailer you are trying to book has just been reserved by another user.");

      this.navigator.executeCommand("TrailerUnavailable")
    }
    else if (validate.AggregatedResult == BookingErrorCode.PeriodUnavailable) {
      // Inform the user about the situation
      var x = await this.UI.alert("Intellitrailer.Booking.UnconfrimedBooking.BookingErrorInvalidPeriod", "Invalid booking period", "Intellitrailer.Booking.UnconfirmedBooking.BookingErrorInvalidPeriodMsg", "The start and/or end time you have selected is not valid. Please review and correct them and try again.");
      this.back();
    }
    else if (validate.AggregatedResult != BookingErrorCode.Valid && validate.ErrorCode == 2048) {
      var x = await this.UI.alert("Intellitrailer.Booking.UnconfrimedBooking.BookingErrorCodeCustomerIsBlocked2", "Account is blocked", "Intellitrailer.Booking.UnconfirmedBooking.BookingErrorCustomerIsBlockedMsg3", "Your account number has been blocked for further rent. Please contact customer service.");
      this.back();
    }
    else if (validate.AggregatedResult != BookingErrorCode.Valid && validate.ErrorCode == 4096) {
      var x = await this.UI.alert("Intellitrailer.Booking.UnconfrimedBooking.BookingErrorCodeMaxBookingsPerDay2", "Maximum bookings per day reached", "Intellitrailer.Booking.UnconfirmedBooking.BookingErrorMaxBookingsPerDayMsg2", "You have reached the maximum number of bookings on one day. Welcome back tomorrow!");
      this.back();
    }
    else if (validate.AggregatedResult != BookingErrorCode.Valid && validate.ErrorCode == 8192) {
      var x = await this.UI.alert("Intellitrailer.Booking.UnconfrimedBooking.BookingErrorCodeMaximumConcurrentBookings2", "Maximum number of concurrent bookings reached", "Intellitrailer.Booking.UnconfirmedBooking.BookingErrorMaximumConcurrentBookingsMsg2", "You have reached the maximum number of concurrent bookings. Please return the active bookings and try again.");
      this.back();
    }
    else {
      var x = await this.UI.alert("Intellitrailer.Booking.UnconfirmedBooking.BookingErrorCodeHead", "Something went wrong!", "Intellitrailer.Booking.UnconfirmedBooking.BookingErrorCodeMsg", "Please try again, or contact support if the problem persists.");

      // Dead end! Log to insights!
      this.Insights.trackTrace("Dead end! CreateBooking", {
        result: validate.AggregatedResult,
        code: validate.ErrorCode,
        userInfo: JSON.stringify(this.BookingDataService?.Query?.Customer)
      });
    }
  }
  public updateSpecialCondition(event) {
    this.specialConditionApproved = event;
  }

  public toggleSavedCard(event) {
    this.useSavedCard = event;
  }

  public toggleTerms(event) {
    this.terms = event;
    this.bookingState.acceptedTerms = event;
    this.BookingDataService.saveState(this.bookingState);
  }

  public bookingUpdatedFromSummary(event) {
    this.bookingState.booking = event;
  }

  public updatePrice(event) {
    if (this.paymentAttemptInProgress && this.hasPaymentChanged(event)) {
      this.paymentSnapshotVersion++;
    }

    this.currentPrice = event;
  }

  private hasPaymentChanged(price: PriceModel): boolean {
    if (!price && !this.currentPrice) {
      return false;
    }

    if (!price || !this.currentPrice) {
      return true;
    }

    return this.currentPrice.ToPay !== price.ToPay
      || this.currentPrice.TotalPrice !== price.TotalPrice
      || this.currentPrice.DiscountedTotalPrice !== price.DiscountedTotalPrice;
  }

  public get verifyProgressValue(): number {
    if (this.verifyProgressCount <= 0) {
      return 0;
    }

    return Math.max((this.verifyProgressCount / this.verifyProgressMaxSeconds) * 100, 3 + 1.0 / 3.0);
  }

  private startVerifyProgress() {
    this.stopVerifyProgress(true);
    this.verifyProgressIntervalId = setInterval(() => {
      if (this.verifyProgressCount < this.verifyProgressMaxSeconds) {
        this.verifyProgressCount++;
      }
    }, 1000);
  }

  private stopVerifyProgress(resetCount: boolean = false) {
    if (this.verifyProgressIntervalId) {
      clearInterval(this.verifyProgressIntervalId);
      this.verifyProgressIntervalId = null;
    }

    if (resetCount) {
      this.verifyProgressCount = 0;
    }
  }

  @HostListener('scroll', ['$event'])
  onScroll(_: any) {
    this.scrolledToBottom = this.isElementVisible('continue-to-agree');
  }

  public updateAddons(event) {
    this.addableProducts = event;
  }
  private next() {
    this.BookingDataService.saveState(this.bookingState);

    if (this.bookingState.existingBooking) {
      this.BookingDataService.showChangeBookingBanner(false);
    }

    this.navigator.executeCommand("Next");
  }

  private async showAddonPopup(): Promise<boolean> {
    // Loop through all products and ask if not added
    for (let product of this.addableProducts) {
      if (product.AskIfNotSelected && !product.IsSelected) {

        const dialogRef = this.Dialog.open(AddonPopupComponent, {
          width: '350px',
          position: { top: '50px' },
          data: { product: product }
        });

        var result = await dialogRef.afterClosed().toPromise();

        // Re-add if user selects that
        if (result === true) {
          this.addAddon(product);
        }
      }
    }

    return true;
  }

  private addAddon(product: ObjectTypeInfo) {
    if (this.bookingState.booking.AddedProducts.indexOf(product.Id + ";") < 0) {
      this.bookingState.booking.AddedProducts += product.Id + ";";
      this.bookingState.booking.AddedProductIds.push(product.Id);
      product.IsSelected = true;
    }

    for (var i of this.addableProducts) {
      if (i.Id == product.Id || !i.IsSelected) continue;

      if (i.CheckCondition && eval(i.CheckCondition) !== true) {
        this.removeAddon(i);
      }
    }
  }

  private removeAddon(product: ObjectTypeInfo) {
    product.IsSelected = false;

    this.bookingState.booking.AddedProducts = this.bookingState.booking.AddedProducts.replace(product.Id + ";", "");
    if (this.bookingState.booking.AddedProductIds.indexOf(product.Id) >= 0) this.bookingState.booking.AddedProductIds.splice(this.bookingState.booking.AddedProductIds.indexOf(product.Id), 1);
  }
  private isElementVisible(elementId: string): boolean {
    let rect = document.getElementById(elementId)?.getBoundingClientRect();
    if (!rect) {
      return false;
    }
    return rect.top >= 0 && rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth);
  }

  private async delay(ms: number): Promise<void> {
    await new Promise(resolve => setTimeout(resolve, ms));
  }

}
